<template lang="html">
  <el-row class="bg-eee pd-tb10 border-radio10">
    <el-col :span="22" :offset="1">
    <el-row class="fs12">
      请输入标题
    </el-row>
      <el-row class="pd-tb10">
        <HdEditor
          v-model="questionData.content"
        />
        <!-- <el-input v-model="questionData.content"  placeholder="试题描述"></el-input> -->
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'HdTitle',
  data(){
    return {
      questionData:{
        answer   :'',
        content :"",
        analysis:"",
      },
      uploadImgServer:""

    }
  },
  props:['isClear','default'],
  created(){
    let _self = this;

    _self.isDefault();
  },
  methods:{
    isDefault(){
      let _self = this;

      if(_self.default != undefined){
        _self.questionData.content  = _self.default.content;
        _self.questionData.answer   = _self.default.answer;
        _self.questionData.analysis = _self.default.analysis;
      }
    }
  },
  watch:{
    questionData:{
      handler(val){
        let _self = this;
        _self.$emit('questionData',val)
      },
      deep: true,
    },
    isClear:{
      handler(val){
        let _self = this;
        if(_self.isClear){
          new Promise((resolve,reject)=>{
            _self.questionData = {
              answer   :'',
              content :"",
              analysis:""
            };
            resolve()
          }).then(()=>{
            _self.$emit("clearState",true)
          })
        }
      },
      deep: true,
    },
    default:{
      handler(val){
        let _self = this;
      },
      deep: true,
    },
  }
}
</script>
<style lang="scss" scoped>
.center{
  display: flex;
  align-items: center;
}
.option{
      font-size: 14px;
    margin: 15px 5px;
}
.bg-eee{
      background: #eee;
}
.border-radio10 {
    border-radius: 10px;
}
</style>